import { Controller } from "@hotwired/stimulus"

// Mega-menú de "Temas": se abre al posar el mouse sobre el link y se cierra
// al salir, con una pequeña espera para poder cruzar el espacio entre el link
// y el panel sin que se cierre. El clic del link navega normal.
const CLOSE_DELAY_MS = 150

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.closeNow = () => this.close()
    document.addEventListener("turbo:before-visit", this.closeNow)
    document.addEventListener("turbo:before-cache", this.closeNow)
    // En documento y no en el header: al abrir por hover el foco sigue en
    // <body>, así que un keydown declarado en el header nunca llegaría.
    this.closeOnEscapeKey = (event) => {
      if (event.key === "Escape") this.close()
    }
    document.addEventListener("keydown", this.closeOnEscapeKey)
  }

  disconnect() {
    clearTimeout(this.timeout)
    document.removeEventListener("turbo:before-visit", this.closeNow)
    document.removeEventListener("turbo:before-cache", this.closeNow)
    document.removeEventListener("keydown", this.closeOnEscapeKey)
  }

  open() {
    clearTimeout(this.timeout)
    this.panelTarget.classList.remove("hidden")
  }

  scheduleClose() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.close(), CLOSE_DELAY_MS)
  }

  close() {
    clearTimeout(this.timeout)
    this.panelTarget.classList.add("hidden")
  }
}
